import { currentUserToken, getAPIBaseUrlVersion1 } from "../utils/constants";
import { createApiClient } from "./createApiClient";

export default createApiClient({
  baseURL: getAPIBaseUrlVersion1(),
  getToken: currentUserToken,
});
